/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import RETAIL from '../BaseComponent/RETAIL'
import FromToPicker from '../BaseComponent/FromToPicker'

class SetLeave extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: '',
      fromDate: '',
      toDate: '',
      drivers: []
    }
  }
  componentDidMount() {
    http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_DRIVER}`, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            drivers: response.data.object
          })
        }
        // alert(JSON.stringify(response.data))
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
        console.log(error)
      })
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  addLeave() {
    var driver = document.getElementById('driver').value
    let fromDate = this.state.fromDate
    let toDate = this.state.toDate
    var driverError = false
    var toDateError = false
    var fromDateError = false
    var formError = false
    if (driver == '') {
      formError = true
      driverError = true
      message.error('رساننده انتخاب شود')
    } else {
      if (!driverError) {
        this.setState({
          error: ''
        })
      }
    }

    if (fromDate == '') {
      formError = true
      fromDateError = true
      message.error(' تاریخ شروع مرخصی را تعیین کنید')
    } else {
      if (!formError) {
        this.setState({
          error: ''
        })
      }
    }

    if (toDate == '') {
      formError = true
      toDateError = true
      message.error(' تاریخ پایان مرخصی را تعیین کنید')
    } else {
      if (!formError) {
        this.setState({
          error: ''
        })
      }
    }
    if ((fromDate != '' || fromDate == null) && isNaN(fromDate)) {
      formError = true
      toDateError = true
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((toDate != '' || toDate == null) && isNaN(toDate)) {
      formError = true
      toDateError = true
      message.error('فرمت تاریخ انتها صحیح نیست')
    }

    if (!formError) {
      let data = {
        driverId: driver,
        from: fromDate,
        to: toDate
      }

      http
        .post(`${RETAIL.RETAIL_MANAGE_DRIVER_LEAVE_RECORD}`, data)
        .then((response) => {
          if (response.data.error == null) {
            message.success('مرخصی با موفقیت اضافه شد')
            setInterval(() => {
              window.location.assign('/reportLeave')
            }, 2000)
          } else {
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  submit(e) {
    e.preventDefault()
  }
  render() {
    var {fromDate, toDate} = this.state
    return (
      <div className={'rtl'}>
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/dashboard'}>به روزرسان</Link>
            </li>
            <li>
              <Link to={'/Drivers'}>رساننده ها</Link>
            </li>
            <li>ثبت مرخصی</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>ثبت مرخصی</p>
            </div>
            <FromToPicker
              onChangeFromDate={this.handleChangeFromDate}
              onChangeToDate={this.handleChangeToDate}
              fromLabel="تاریخ شروع "
              toLabel="تاریخ پایان "
              force={true}
              defaulValue={true}
              fromId="from"
              toId="to"
            />
            <div className="formComponent">
              <label className="mb-2 mr-sm-2">
                رساننده : <span className="requireFiled">*</span>
              </label>
              <select className="form-control mb-2 mr-sm-2" id="driver">
                <option value="">--------</option>
                {this.state.drivers.map((driver, index) => (
                  <option value={driver.personId}>{driver.name}</option>
                ))}
              </select>

              <button className="btn btn-info btn-block" onClick={this.addLeave.bind(this)}>
                ثبت مرخصی
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default SetLeave
